import React, {ForwardRefExoticComponent, forwardRef, RefAttributes} from "react";
import ItemPrice from "../../molecules/ItemPrice";
import {AddToCartButton} from "../../cart/AddToCartButton/AddToCartButtonPortal";
import {LookItemType} from "./LookTypes";
import AddToWishlistButton from "../../wishlist/AddToWishlistButton/AddToWishlistButton";
import {useTranslation} from "react-i18next";

type MobilePopupPropsType = {
  activeProduct: LookItemType;
  handleClose: () => void;
  isClosing: boolean;
} & RefAttributes<HTMLDivElement>;

const MobilePopup: ForwardRefExoticComponent<MobilePopupPropsType> = forwardRef<HTMLDivElement, MobilePopupPropsType>(
  ({activeProduct, handleClose, isClosing}, divRef) => {
    const {imgUrl1x, imgUrl2x, itemName} = activeProduct;
    const {attributes, images, manufacturer, prices, title} = activeProduct.item;
    const {t} = useTranslation();

    return (
      <div className={`mobile-popup mobile-popup__active${isClosing ? " mobile-popup__closing" : ""}`} ref={divRef}>
        <div className="mobile-popup-content">
          <button className="tooltip-close" onClick={handleClose}>
            ×
          </button>
          <a href={activeProduct.item.url} className="tooltip-content">
            <img
              src={imgUrl1x}
              className="tooltip-image"
              srcSet={`${imgUrl1x ?? ""} 1x, ${imgUrl2x ?? ""} 2x`}
              alt={title}
            />
            <div className="tooltip-info">
              {activeProduct.isAlternative && <div className="similar-product">{t("shopthelook.similarProduct")}</div>}
              <div className="tooltip-brand">{manufacturer}</div>
              <div className="tooltip-title">{itemName}</div>
              <div className="tooltip-price">
                <ItemPrice images={images} itemAttributes={attributes} prices={prices} />
              </div>
            </div>
          </a>
          <div className="button-group">
            <AddToCartButton itemId={activeProduct.item.itemId} />
            <AddToWishlistButton itemId={activeProduct.item.itemId} customClass="heart-button" size="big" />
          </div>
        </div>
      </div>
    );
  },
);

MobilePopup.displayName = "MobilePopup";

export default MobilePopup;
